export const Cookies = {
  set(name: string, value: string | string[]) {
    const farFuture = new Date()
    farFuture.setFullYear(2030) // should be enough.

    const cookieParts = {
      [name]: JSON.stringify(value),
      expires: farFuture.toUTCString(),
      path: '/',
    }

    document.cookie = Object.keys(cookieParts)
      .map((key) => `${key}=${cookieParts[key]}`)
      .join('; ')
  },
  list() {
    if (document.cookie === '') {
      return []
    }

    return document.cookie.split('; ').map((cookie) => {
      const [name, stringValue] = cookie.split('=')
      let value
      try {
        value = JSON.parse(stringValue)
      } catch (err) {
        value = stringValue
      } finally {
        return { name, value }
      }
    })
  },
  get(name: string) {
    return Cookies.list().filter((cookie) => cookie.name === name)[0]
  },
}
